import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';

import { map } from 'rxjs';

import { DefaultPaginatorResponse } from 'src/app/shared/models/pagination.models';

// TODO: delete once BE paginator response migration is stable in all envs.
// Converts the legacy flat paginator shape (`{ content, totalPages, totalElements, ... }`)
// into the new nested shape (`{ content, page: { size, number, totalElements, totalPages } }`).
// Shallow-walks the response body so nested paginators (e.g. `response.orgMetrics`,
// `response.rows`, `response.content` in CRM responses) are converted too.
export const legacyPaginatorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    map((event) =>
      event instanceof HttpResponse
        ? event.clone({ body: convertLegacyPaginators(event.body) })
        : event
    )
  );

interface LegacyPaginator {
  content: unknown[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
}

type NewPaginator = DefaultPaginatorResponse & { content: unknown[] };

function convertLegacyPaginators(body: unknown): unknown {
  if (!body || typeof body !== 'object') return body;
  if (isLegacyPaginator(body)) return toNewShape(body);

  const record = body as Record<string, unknown>;
  let cloned: Record<string, unknown> | null = null;
  for (const key of Object.keys(record)) {
    const value = record[key];
    if (isLegacyPaginator(value)) {
      cloned ??= { ...record };
      cloned[key] = toNewShape(value);
    }
  }
  return cloned ?? body;
}

function isLegacyPaginator(value: unknown): value is LegacyPaginator {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Record<string, unknown>;
  return (
    Array.isArray(candidate['content']) &&
    typeof candidate['totalPages'] === 'number' &&
    typeof candidate['totalElements'] === 'number' &&
    typeof candidate['size'] === 'number' &&
    typeof candidate['number'] === 'number'
  );
}

function toNewShape(legacy: LegacyPaginator): NewPaginator {
  return {
    content: legacy.content,
    page: {
      size: legacy.size,
      number: legacy.number,
      totalElements: legacy.totalElements,
      totalPages: legacy.totalPages
    }
  };
}
